<div class="no-search-result-wrapper" [ngClass]="{'hide-image': hideImage}">
  <div class="image-wrapper" *ngIf="!hideImage">
    <img ngSrc="{{src}}"
         alt="No search result"
         priority fill/>
  </div>
  <div class="label">
    {{ text }}
  </div>
</div>
